let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5uj8R")).then(() => parcelRequire('kfaV9'));